import _ from 'underscore';
import Constants from '../constants/constants';
import { formValidation } from '../util/formValidation';

var SvgElement = require("tmds/SvgElement");
var Point = require("tmds/geometry/Point");
var CompositePointSymbol = require("tmds/symbols/CompositePointSymbol");
var SimplePointSymbol = require("tmds/symbols/SimplePointSymbol");
var TextSymbol = require("tmds/symbols/TextSymbol");
var Color = Constants.Colors;

function mpIsLeft(mpOne, sfxOne, mpTwo, sfxTwo, milePostRangeList, haveGraph) {

    console.log('checking if mpOne:' + mpOne + sfxOne + ' is left of mpTwo:' + mpTwo + sfxTwo);

    if (milePostRangeList.length === 1) {
        console.log('MPs occur in same range');
        var range = milePostRangeList[0];
        if (range.from > range.to) {
            console.log('range decreasing left to Right');
            var result = mpOne > mpTwo && formValidation.suffixesMatch(sfxOne, sfxTwo);
            console.log('checking if ', range.from + ' > ' + mpOne + ' > ' + mpTwo + ' > ' + range.to, 'is true, result is: ', result);
            return result;
        }
        else if (range.from < range.to) {
            console.log('range increasing left to Right');
            var result = mpOne < mpTwo && formValidation.suffixesMatch(sfxOne, sfxTwo);
            console.log('checking if ', range.from + ' < ' + mpOne + ' < ' + mpTwo + ' < ' + range.to, 'is true, result is: ', result);
            return result;
        }
    }
    else {
        if (haveGraph) {
            console.log('MPs MIGHT occur across ranges, need to keep checking');
            //calculate across ranges

            //go through each range and determine which range mpOne and mpTwo are in
            var mpOneResult = getRangeWhereMpExists(mpOne, sfxOne, milePostRangeList);
            var mpTwoResult = getRangeWhereMpExists(mpTwo, sfxTwo, milePostRangeList);

            var rangeOneFlipped = mpOneResult.fnode > mpOneResult.tnode;
            var rangeTwoFlipped = mpTwoResult.fnode > mpTwoResult.tnode;


            if (mpOneResult && mpTwoResult) {


                if (mpOneResult == mpTwoResult) {
                    //occur in the same range
                    if (mpOneResult.from < mpTwoResult.to) {
                        //descending from to to
                        return mpOne < mpTwo
                    }
                    else
                        return mpOne > mpTwo
                }
                else if (mpOneResult.fnode === mpTwoResult.fnode) {
                    //occur in parallel ranges
                    console.error('MPs are parallel, who knows which is left?');
                    return null;
                }
                else {
                    if (rangeOneFlipped) {
                        return mpOneResult.tnode < mpTwoResult.tnode;
                    }
                    else if (rangeTwoFlipped) {
                        return mpOneResult.fnode < mpTwoResult.tnode;
                    }
                    else {
                        return mpOneResult.fnode < mpTwoResult.fnode;
                    }
                }

            }
            else {
                //did not find both MPs
                console.error('Did not find both MPs when running mpIsLeft for ', mpOne, sfxOne, mpTwo, sfxTwo);
            }
        }
        else {//using MF range table
            console.log('MPs occur across ranges, need to keep checking');
            //calculate across ranges

            //go through each range and determine which range mpOne and mpTwo are in
            var mpOneFound = false,
                mpTwoFound = false,
                mpOneIndex,
                mpTwoIndex,
                uselessVar;

            var l = milePostRangeList.length;
            for (var i = 0; i < l; i++) {
                var range = milePostRangeList[i];

                //is the MP in the range?
                if (((range.from <= mpOne && mpOne <= range.to && range.from < range.to) ||
                    (range.from >= mpOne && mpOne >= range.to && range.from > range.to)) &&
                    formValidation.suffixesMatch(range.sfx, sfxOne)) {
                    mpOneFound = true;
                    console.log('mpOneFound in range: ', i);
                }

                if (((range.from <= mpTwo && mpTwo <= range.to && range.from < range.to) ||
                    (range.from >= mpTwo && mpTwo >= range.to && range.from > range.to)) &&
                    formValidation.suffixesMatch(range.sfx, sfxTwo)) {
                    mpTwoFound = true;
                    console.log('mpTwoFound in range: ', i);
                }

                //if both found
                if (mpOneFound && mpTwoFound) {
                    console.log('both MPs found in same range: ', i);
                    //both are in this range, use recursion to find it using
                    if (range.from > range.to) {
                        //decreasing left to Right
                        console.log('result: ', (mpOne > mpTwo) && formValidation.suffixesMatch(sfxOne, sfxTwo));
                        return (mpOne > mpTwo) && formValidation.suffixesMatch(sfxOne, sfxTwo);
                    }
                    else if (range.from < range.to) {
                        //increasing left to right
                        console.log('result: ', (mpOne < mpTwo) && formValidation.suffixesMatch(sfxOne, sfxTwo));
                        return (mpOne < mpTwo) && formValidation.suffixesMatch(sfxOne, sfxTwo);
                    }
                }
                else {//otherwise find the indexes where the MPs were found
                    mpOneFound ? mpOneIndex = i : uselessVar = 1;
                    mpTwoFound ? mpTwoIndex = i : uselessVar = 1;
                }
            }

            //compare the indexes where found to determine if mpOne isLeft of mpTwo
            if (mpOneIndex > -1 && mpTwoIndex > -1) {
                console.log('MPs found in different ranges: mpOneIndex: ' + mpOneIndex + ' mpTwoIndex: ' + mpTwoIndex + '');
                console.log('checking if mpOneIndex < mpTwoIndex, result is: ', mpOneIndex < mpTwoIndex);
                return mpOneIndex < mpTwoIndex;
            }
            else {
                console.error('both MPs not found!')
            }
        }
    }
}

function convertTextToRangedText(bmp, bmpSuffix, emp, empSuffix, accountForParallelism, restriction, milePostRangeList, haveGraph) {
    if (haveGraph) {
        return convertTextToRangedTextGraphBased(bmp, bmpSuffix, emp, empSuffix, accountForParallelism, restriction, milePostRangeList, haveGraph);
    }
    else {
        return convertTextToRangedTextMfBased(bmp, bmpSuffix, emp, empSuffix, restriction, milePostRangeList, haveGraph);
    }
}

/**
 * uses the given bmp, emp & suffixes to create an object which lists all the ranges the restriction goes through
 * also determines which mp is left of the other
 * @param bmp optional left mile post
 * @param bmpSuffix optional right milepost
 * @param emp
 * @param empSuffix
 * @returns {{mpPairs: Array, trackNames: (Array|*), isContiguous: boolean}}
 */
function convertTextToRangedTextGraphBased(bmp, bmpSuffix, emp, empSuffix, accountForParallelism, restriction, milePostRangeList, haveGraph) {
    var currentRangedText;
    console.log('converting to ranged text');

    var mpPairs, trackNames;

    var leftMp = parseFloat(bmp);
    var rightMp = parseFloat(emp);
    var leftSuffix = bmpSuffix;
    var rightSuffix = empSuffix;

    if (isNaN(leftMp) && isNaN(rightMp)) {//don't check the suffixes because null can be a valid value
        console.log('no MPs given');
    }

    if (isNaN(leftMp) || isNaN(rightMp)) {
        console.log('only one mp present:', leftMp, rightMp);
    }
    else {
        var mpLeft = mpIsLeft(leftMp, leftSuffix, rightMp, rightSuffix, milePostRangeList, haveGraph);
        if (mpLeft == null) {
            //parallel ranges, need to warn the user!!!
            return {
                mpPairs: [],
                trackNames: [],
                isContiguous: true,
                isParallel: true
            };
        }
        else if (!mpLeft) {
            var temp = leftMp;
            leftMp = rightMp;
            rightMp = temp;
            var tempSfx = leftSuffix;
            leftSuffix = rightSuffix;
            rightSuffix = tempSfx;
            console.log('switched the MPs for all future calculations left mp: ' + leftMp + leftSuffix + ' right mp: ' + rightMp + rightSuffix);
        }
        else {
            console.log('Did NOT switch the MPs');
        }
    }

    mpPairs = [];
    var isContiguous;
    if (!isNaN(leftMp) && !isNaN(rightMp)) {

        var lmpResult = getRangeWhereMpExists(leftMp, leftSuffix, milePostRangeList);
        console.log('lmp host range', JSON.stringify(lmpResult));

        var leftRangeIsParallel = milePostRangeList.filter(function (r) {
            //parallel if there is another range with the same nodes and it isn't this range
            return r.fnode == lmpResult.fnode && r.tnode == lmpResult.tnode && (r != lmpResult)
        }).length > 0;

        var rmpResult = getRangeWhereMpExists(rightMp, rightSuffix, milePostRangeList);
        console.log('rmp host range', JSON.stringify(rmpResult));

        var rightRangeIsParallel = milePostRangeList.filter(function (r) {
            //parallel if there is another range with the same nodes and it isn't this range
            return r.fnode == rmpResult.fnode && r.tnode == rmpResult.tnode && (r != rmpResult)
        }).length > 0;

        if (lmpResult === rmpResult) {
            //occur in the same range
            mpPairs.push({ leftMp: leftMp, rightMp: rightMp, suffix: lmpResult.sfx });
        }
        // else if (leftRangeIsParallel && accountForParallelism) {
        //     //we only want MP ranges for the range that the right mp falls into because it falls into a parallel range
        //     mpPairs.push({leftMp: rmpResult.from, rightMp: rightMp, suffix: rmpResult.sfx});
        //     //todo: warn the user
        //     //dispatcher.dispatch({
        //     //    type:ActionTypes.AVAILABLE_TRACKS_FILTERED,
        //     //    message:[{field: 'availableTracks', message: 'An available track has been filtered due to your MP selection', type: 'warning'}]
        //     //})
        // }
        // else if (rightRangeIsParallel && accountForParallelism) {
        //     //we only want MP ranges for the range that the left mp falls into because it falls into a parallel range
        //     mpPairs.push({leftMp: leftMp, rightMp: lmpResult.to, suffix: lmpResult.sfx});
        //     //todo: warn the user
        //     //dispatcher.dispatch({
        //     //    type:ActionTypes.AVAILABLE_TRACKS_FILTERED,
        //     //    message:[{field: 'availableTracks', message: 'An available track has been filtered due to your MP selection', type: 'warning'}]
        //     //})
        //
        // }
        else if (lmpResult.tnode === rmpResult.fnode) {
            //occur in two adjacent ranges
            mpPairs.push({ leftMp: leftMp, rightMp: lmpResult.to, suffix: lmpResult.sfx });
            mpPairs.push({ leftMp: rmpResult.from, rightMp: rightMp, suffix: rmpResult.sfx });
            isContiguous = true;
        }
        else {
            //Iterative breadth first search
            var ranges = [lmpResult];


            for (var i = 0; i < ranges.length; i++) {
                var range = ranges[i];

                //stop if we are looking at the last range where rmp was found
                if (range == rmpResult) {
                    break;
                }
                else if (range.tnode == rmpResult.tnode) { //this range is parallel to the right range, don't search beyond it
                    continue;
                }
                else {
                    //find each range that connects based on node # and push it to the list we're iterating over
                    var connectedRanges = milePostRangeList.filter(function (r) {
                        return (range.tnode == r.fnode) || (range.tnode == r.tnode)
                    });

                    connectedRanges.forEach(function (r) {
                        if (ranges.indexOf(r) < 0)
                            ranges.push(r);
                    });

                }
            }

            //Sort the ranges by tnode
            ranges = _.sortBy(ranges, "tnode");

            //Convert full ranges into mp pairs
            _.forEach(ranges, function (r) {//cut down the ranges as appropriate to get the mpPairs
                if (r == lmpResult) {
                    //push customized start range
                    mpPairs.push({ leftMp: leftMp, rightMp: lmpResult.to, suffix: lmpResult.sfx });

                }
                else if (r == rmpResult) {
                    //push customized end range
                    mpPairs.push({ leftMp: rmpResult.from, rightMp: rightMp, suffix: rmpResult.sfx });
                }
                else {
                    //push entire range if it is not parallel to one of the host ranges
                    if (!((r.fnode == lmpResult.fnode && r.tnode == lmpResult.tnode) || (r.fnode == rmpResult.fnode && r.tnode == rmpResult.tnode)))
                        mpPairs.push({ leftMp: r.from, rightMp: r.to, suffix: r.sfx })
                }
            });
            isContiguous = false;

        }

        trackNames = restriction.tracks.map(function (tr) {
            return tr.name
        });

        console.log('all ranges and tracks found: ', JSON.stringify(mpPairs), trackNames);
        currentRangedText = {
            mpPairs: mpPairs,
            trackNames: trackNames,
            isContiguous: isContiguous
        };
    }
    else {
        currentRangedText = {
            mpPairs: [],
            trackNames: [],
            isContiguous: true
        };
    }
    console.log('finished converting to ranged text:', JSON.stringify(currentRangedText));

    return currentRangedText;
}

function convertTextToRangedTextMfBased(bmp, bmpSuffix, emp, empSuffix, restriction, milePostRangeList, haveGraph) {
    var currentRangedText;
    console.log('converting to ranged text');

    //if (currentRangedText) {
    //    console.log('existing ranged text found, using that');
    //    return currentRangedText;
    //}


    var mpPairs, trackNames;

    var leftMp = parseFloat(bmp);
    var rightMp = parseFloat(emp);
    var leftSuffix = bmpSuffix;
    var rightSuffix = empSuffix;

    if (isNaN(leftMp) && isNaN(rightMp)) {//don't check the suffixes because null can be a valid value
        console.log('no MPs given');
        //leftMp = parseFloat(restriction.workStartMp);
        //rightMp = parseFloat(restriction.workEndMp);
        //leftSuffix = restriction.workStartMpSuffix;
        //rightSuffix = restriction.workEndMpSuffix;
    }

    if (isNaN(leftMp) || isNaN(rightMp)) {
        console.log('only one mp present:', leftMp, rightMp);
    }
    else {
        if (!mpIsLeft(leftMp, leftSuffix, rightMp, rightSuffix, milePostRangeList, haveGraph)) {
            var temp = leftMp;
            leftMp = rightMp;
            rightMp = temp;
            console.log('switched the MPs for all future calculations left mp: ' + leftMp + ' right mp: ' + rightMp);
            var tempSfx = leftSuffix;
            leftSuffix = rightSuffix;
            rightSuffix = tempSfx;
            console.log('switched the Sfx\'s left sfx: ' + leftSuffix + ' right sfx: ' + rightSuffix);

        }
        else {
            console.log('Did NOT switch the MPs');
        }
    }


    if (!isNaN(leftMp) && !isNaN(rightMp) && restrictionCrossesRanges(leftMp, leftSuffix, rightMp, rightSuffix, milePostRangeList)) {

        mpPairs = [];
        var foundLmp = false;

        //loop through each range
        var l = milePostRangeList.length;
        for (var i = 0; i < l; i++) {

            var range = milePostRangeList[i];
            console.log('range iteration: ', i, range);
            if (!foundLmp) {//only look for the lmp if not found
                if ((range.from <= leftMp && leftMp <= range.to && range.from < range.to) ||
                    (range.from >= leftMp && leftMp >= range.to && range.from > range.to) &&
                    formValidation.suffixesMatch(range.sfx, leftSuffix)) {
                    foundLmp = true;
                    console.log('found lmp in range: ', i);

                    mpPairs.push({ leftMp: leftMp, rightMp: range.to, suffix: leftSuffix });
                    console.log('added first range to mpPairs: ', mpPairs);
                }
            }
            else if (foundLmp) {
                //look for the right MP
                if ((range.from <= rightMp && rightMp <= range.to && range.from < range.to) ||
                    (range.from >= rightMp && rightMp >= range.to && range.from > range.to) &&
                    formValidation.suffixesMatch(range.sfx, rightSuffix)) {

                    console.log('found rmp in range: ', i);

                    mpPairs.push({ leftMp: range.from, rightMp: rightMp, suffix: rightSuffix });
                    console.log('added first range to mpPairs: ', mpPairs);
                    console.log('both MPs found, breaking range loop');
                    break;
                }
                else {
                    //right MP not in the range, so include the whole range!
                    mpPairs.push({ leftMp: range.from, rightMp: range.to, suffix: range.sfx });
                    console.log('included entire range', mpPairs);

                }

            }

        }

        trackNames = restriction.tracks.map(function (tr) {
            return tr.name
        });

        console.log('all ranges and tracks found: ', mpPairs, trackNames);
        currentRangedText = {
            mpPairs: mpPairs,
            trackNames: trackNames,
            isContiguous: false
        };

    }
    else {//the restriction occurs within a single range

        //because this range is contiguous, we only need to use a single suffix because they are the same for both MPs
        mpPairs = [{ leftMp: leftMp, rightMp: rightMp, suffix: leftSuffix }];

        trackNames = restriction.tracks.map(function (tr) {
            return tr.name
        });

        currentRangedText = {
            mpPairs: mpPairs,
            trackNames: trackNames,
            isContiguous: true
        };
    }
    console.log('finished converting to ranged text:', currentRangedText);

    return currentRangedText;
}

function restrictionCrossesRanges(lmp, lmpSfx, rmp, rmpSfx, milePostRangeList) {
    console.log('Checking if MPs cross a range change');

    if (milePostRangeList.length === 1) {//only one range exists on this sub, so always false
        console.log('milePostRangeList length is 1, MPs cannot cross a range on this sub');
        return false;
    }
    else {
        //determine if we're crossing ranges
        console.log('milePostRangeList length is ', milePostRangeList.length);
        //foreach range try to find the lmp & rmp, if both are found in the same range, false, otherwise true
        if (!isNaN(lmp) && !isNaN(rmp)) {

            var l = milePostRangeList.length;
            console.log('looking through each range');
            for (var i = 0; i < l; i++) {
                var range = milePostRangeList[i];
                var foundLmp = false, foundRmp = false;
                if ((range.from <= lmp && lmp <= range.to && range.from < range.to) ||
                    (range.from >= lmp && lmp >= range.to && range.from > range.to) &&
                    formValidation.suffixesMatch(range.sfx, lmpSfx)) {
                    foundLmp = true;
                    console.log('found lmp in range: ', i)
                }

                if ((range.from <= rmp && rmp <= range.to && range.from < range.to) ||
                    (range.from >= rmp && rmp >= range.to && range.from > range.to) &&
                    formValidation.suffixesMatch(range.sfx, rmpSfx)) {
                    foundRmp = true;
                    console.log('found rmp in range: ', i)

                }
                if (foundLmp && foundRmp) {
                    //both found in this range!!
                    console.log('lmp & rmp found in range: ', i);
                    return false;
                }
            }
        }
        else {
            console.error('both MPs were not on the restriction.');
        }
    }
    console.log('both MPs not found in same range. MPs cross a range change');
    return true;
}

function getRangeWhereMpExists(mp, sfx, milePostRangeList) {
    var hostRanges = [];

    var len = milePostRangeList.length;
    for (var i = 0; i < len; i++) {
        var range = milePostRangeList[i];
        if (inRange(range, mp, sfx)) {
            hostRanges.push(range);
        }
    }

    if (hostRanges.length < 1) {
        console.error('Could not find MP ', mp + sfx, ' in any range!');
        return null
    }
    else if (hostRanges.length > 1) {
        //return the non-parallel range
        var returnRange;
        hostRanges.forEach(function (hostRange) {//each host
            var ranges = milePostRangeList.filter(function (range) {//each range
                return range.fnode == hostRange.fnode && range.tnode == hostRange.tnode;
            });
            if (ranges.length == 1) {
                returnRange = hostRange;
            }
        });
        return returnRange;
    }
    else {
        return hostRanges[0];
    }

}

function inRange(range, mp, sfx) {
    if (((range.from <= mp && mp <= range.to && range.from < range.to) ||
        (range.from >= mp && mp >= range.to && range.from > range.to)) &&
        formValidation.suffixesMatch(range.sfx, sfx)) {
        return true;
    }
    return false;
}

/**
 * return list of track names that fall in between the given bmp and emp
 * @param bmp
 * @param bmpSfx
 * @param emp
 * @param empSfx
 * @param subdivision
 * @param trackElements
 * @param defaultTracks
 * @param trackFields
 * @param restriction
 * @param milePostRangeList
 * @param haveGraph
 * @param validRenderTypes
 * @returns {Array}
 */
function getDistinctTrackNames(bmp, bmpSfx, emp, empSfx, subdivision, trackElements, trackFields, restriction, milePostRangeList, haveGraph, validRenderTypes) {
    var outTrackNames = [];
    var renderRejectedGuids = [];

    var rangedText = convertTextToRangedText(bmp, bmpSfx, emp, empSfx, true, restriction, milePostRangeList, haveGraph);

    rangedText.mpPairs.forEach(function (range) {//for each range

        var sfx = range.suffix,
            lmp = range.leftMp,
            rmp = range.rightMp;

        trackElements.elements.forEach(function (elem) {//go through all the track elements
            var attrs = elem.attributes,
                trkSub = attrs[trackFields.TRACK_SUBDIV],
                trkTrackName = attrs[trackFields.TRACK_NAME],
                trkBMP = attrs[trackFields.TRACK_BMP],
                trkEMP = attrs[trackFields.TRACK_EMP],
                trkMPSuf = attrs[trackFields.TRACK_MPSUF],
                renderType = attrs['renderType'];

            if (trkSub === subdivision) {
                if ((trkBMP < trkEMP && lmp < rmp && (		// Guid increasing, range increasing
                    (trkBMP < lmp && lmp < trkEMP && formValidation.suffixesMatch(sfx, trkMPSuf)) || 	// 		the track that can host bmp
                    (trkBMP < rmp && rmp < trkEMP && formValidation.suffixesMatch(sfx, trkMPSuf)) || 	// 		the track that can host emp
                    (trkBMP >= lmp && trkBMP < rmp && trkEMP > lmp && trkEMP <= rmp && formValidation.suffixesMatch(sfx, trkMPSuf))  // 		inner tracks
                )) ||
                    (trkBMP < trkEMP && lmp > rmp && (		// Guid increasing, range decreasing
                        (trkBMP > lmp && lmp > trkEMP && formValidation.suffixesMatch(sfx, trkMPSuf)) || 	// 		the track that can host bmp
                        (trkBMP > rmp && rmp > trkEMP && formValidation.suffixesMatch(sfx, trkMPSuf)) || 	// 		the track that can host emp
                        (trkBMP <= lmp && trkBMP > rmp && trkEMP < lmp && trkEMP >= rmp && formValidation.suffixesMatch(sfx, trkMPSuf))  // 		inner tracks
                    )) ||
                    (trkBMP > trkEMP && lmp > rmp && (		// Guid decreasing, range decreasing
                        (trkBMP > lmp && lmp > trkEMP && formValidation.suffixesMatch(sfx, trkMPSuf)) || 	// 		the track that can host bmp
                        (trkBMP > rmp && rmp > trkEMP && formValidation.suffixesMatch(sfx, trkMPSuf)) || 	// 		the track that can host emp
                        (trkBMP <= lmp && trkBMP > rmp && trkEMP < lmp && trkEMP >= rmp && formValidation.suffixesMatch(sfx, trkMPSuf)) // 		inner tracks
                    )) ||
                    (trkBMP > trkEMP && lmp < rmp && (		// Guid decreasing, range increasing
                        (trkBMP < lmp && lmp < trkEMP && formValidation.suffixesMatch(sfx, trkMPSuf)) || 	// 		the track that can host bmp
                        (trkBMP < rmp && rmp < trkEMP && formValidation.suffixesMatch(sfx, trkMPSuf)) || 	// 		the track that can host emp
                        (trkBMP >= lmp && trkBMP < rmp && trkEMP > lmp && trkEMP <= rmp && formValidation.suffixesMatch(sfx, trkMPSuf)) // 		inner tracks
                    ))) {

                    if (validRenderTypes.indexOf(renderType) > -1) {
                        // if the track name not included in the output array, add it.
                        if (outTrackNames.indexOf(trkTrackName) === -1) {
                            outTrackNames.push(trkTrackName);
                        }
                    }
                    else {
                        renderRejectedGuids.push(elem);
                    }
                }
            }
        });
    });

    console.log('Rejected highlighting the following guids because of invalid render type:', renderRejectedGuids);
    return outTrackNames;
}

function getPartialHostGuid(originalGuid, bmp, emp, trackFields) {
    var guidBmp = originalGuid.attributes[trackFields.TRACK_BMP];
    var guidEmp = originalGuid.attributes[trackFields.TRACK_EMP];
    var newLeftPoint;
    var newRightPoint;


    var newGuid = new SvgElement(originalGuid.toJson()),
        newAttr = newGuid.attributes,
        newGeom = newGuid.geometry;

    var bmpPoint = interpolateMpOnGuid(originalGuid, bmp, trackFields);
    var empPoint = interpolateMpOnGuid(originalGuid, emp, trackFields);
    var guidBmpPoint = interpolateMpOnGuid(originalGuid, guidBmp, trackFields);
    var guidEmpPoint = interpolateMpOnGuid(originalGuid, guidEmp, trackFields);

    if (bmp == emp) {
        //Create a 0 length "sliver" guid
        newGeom.x1 = bmpPoint.x;
        newGeom.y1 = bmpPoint.y;
        newGeom.x2 = bmpPoint.x;
        newGeom.y2 = bmpPoint.y;
        newGuid.setGeometry(newGeom);

        newAttr[trackFields.TRACK_BMP] = bmp;
        newAttr[trackFields.TRACK_RX] = bmpPoint.x;
        newAttr[trackFields.TRACK_RY] = bmpPoint.y;
        newAttr[trackFields.TRACK_EMP] = emp;
        newAttr[trackFields.TRACK_LX] = bmpPoint.x;
        newAttr[trackFields.TRACK_LY] = bmpPoint.y;
        newGuid.setAttributes(newAttr);
    }
    else {
        if (bmp != guidBmp) { //If the bmp of the restriction does not match we need to change the bmp of the guid
            if (bmpPoint.x > empPoint.x) {
                //bmp is to the right so change the right edge of the guid
                newRightPoint = bmpPoint;

                newGeom.x2 = newRightPoint.x;
                newGeom.y2 = newRightPoint.y;
                newGuid.setGeometry(newGeom);

                newAttr[trackFields.TRACK_BMP] = bmp;
                newAttr[trackFields.TRACK_RX] = newRightPoint.x;
                newAttr[trackFields.TRACK_RY] = newRightPoint.y;
                newGuid.setAttributes(newAttr);
            }
            else {
                //bmp is to the left so change the left edge of the guid
                newLeftPoint = bmpPoint;

                //Update line geometry
                newGeom.x1 = newLeftPoint.x;
                newGeom.y1 = newLeftPoint.y;
                newGuid.setGeometry(newGeom);

                //Update guid attributes, bmp, lx, ly
                newAttr[trackFields.TRACK_BMP] = bmp;
                newAttr[trackFields.TRACK_LX] = newLeftPoint.x;
                newAttr[trackFields.TRACK_LY] = newLeftPoint.y;
                newGuid.setAttributes(newAttr);
            }
        }

        if (emp != guidEmp) { //If the emp of teh restriction does not match we need to change the emp of the guid
            if (empPoint.x > bmpPoint.x) {
                //emp is to the right so change the right edge of the guid
                newRightPoint = empPoint;

                newGeom.x2 = newRightPoint.x;
                newGeom.y2 = newRightPoint.y;
                newGuid.setGeometry(newGeom);

                newAttr[trackFields.TRACK_EMP] = emp;
                newAttr[trackFields.TRACK_RX] = newRightPoint.x;
                newAttr[trackFields.TRACK_RY] = newRightPoint.y;
                newGuid.setAttributes(newAttr);
            }
            else {
                newLeftPoint = empPoint;

                //Update line geometry
                newGeom.x1 = newLeftPoint.x;
                newGeom.y1 = newLeftPoint.y;
                newGuid.setGeometry(newGeom);

                //Update guid attributes, emp, lx, ly
                newAttr[trackFields.TRACK_EMP] = emp;
                newAttr[trackFields.TRACK_LX] = newLeftPoint.x;
                newAttr[trackFields.TRACK_LY] = newLeftPoint.y;
                newGuid.setAttributes(newAttr);
            }
        }
    }

    return newGuid;
}

function getPartialGuid(originalGuid, bmp, emp, trackFields) {
    var guidBmp = originalGuid.attributes[trackFields.TRACK_BMP];
    var guidEmp = originalGuid.attributes[trackFields.TRACK_EMP];
    var newLeftPoint;
    var newRightPoint;


    var newGuid = new SvgElement(originalGuid.toJson()),
        newAttr = newGuid.attributes,
        newGeom = newGuid.geometry;

    var bmpPoint = interpolateMpOnGuid(originalGuid, bmp, trackFields);
    var empPoint = interpolateMpOnGuid(originalGuid, emp, trackFields);
    var guidBmpPoint = interpolateMpOnGuid(originalGuid, guidBmp, trackFields);
    var guidEmpPoint = interpolateMpOnGuid(originalGuid, guidEmp, trackFields);

    if (bmp == emp) {
        //Create a 0 length "sliver" guid
        newGeom.x1 = bmpPoint.x;
        newGeom.y1 = bmpPoint.y;
        newGeom.x2 = bmpPoint.x;
        newGeom.y2 = bmpPoint.y;
        newGuid.setGeometry(newGeom);

        newAttr[trackFields.TRACK_BMP] = bmp;
        newAttr[trackFields.TRACK_RX] = bmpPoint.x;
        newAttr[trackFields.TRACK_RY] = bmpPoint.y;
        newAttr[trackFields.TRACK_EMP] = emp;
        newAttr[trackFields.TRACK_LX] = bmpPoint.x;
        newAttr[trackFields.TRACK_LY] = bmpPoint.y;
        newGuid.setAttributes(newAttr);
    }
    else {
        if (bmp != guidBmp) { //If the bmp of the restriction does not match we need to change the bmp of the guid
            if (bmpPoint.x > empPoint.x) {
                //bmp is to the right so change the right edge of the guid
                newRightPoint = bmpPoint;

                newGeom.x2 = newRightPoint.x;
                newGeom.y2 = newRightPoint.y;
                newGuid.setGeometry(newGeom);

                newAttr[trackFields.TRACK_BMP] = bmp;
                newAttr[trackFields.TRACK_RX] = newRightPoint.x;
                newAttr[trackFields.TRACK_RY] = newRightPoint.y;
                newGuid.setAttributes(newAttr);
            }
            else {
                //bmp is to the left so change the left edge of the guid
                newLeftPoint = bmpPoint;

                //Update line geometry
                newGeom.x1 = newLeftPoint.x;
                newGeom.y1 = newLeftPoint.y;
                newGuid.setGeometry(newGeom);

                //Update guid attributes, bmp, lx, ly
                newAttr[trackFields.TRACK_BMP] = bmp;
                newAttr[trackFields.TRACK_LX] = newLeftPoint.x;
                newAttr[trackFields.TRACK_LY] = newLeftPoint.y;
                newGuid.setAttributes(newAttr);
            }
        }

        if (emp != guidEmp) { //If the emp of teh restriction does not match we need to change the emp of the guid
            if (empPoint.x > bmpPoint.x) {
                //emp is to the right so change the right edge of the guid
                newRightPoint = empPoint;

                newGeom.x2 = newRightPoint.x;
                newGeom.y2 = newRightPoint.y;
                newGuid.setGeometry(newGeom);

                newAttr[trackFields.TRACK_EMP] = emp;
                newAttr[trackFields.TRACK_RX] = newRightPoint.x;
                newAttr[trackFields.TRACK_RY] = newRightPoint.y;
                newGuid.setAttributes(newAttr);
            }
            else {
                newLeftPoint = empPoint;

                //Update line geometry
                newGeom.x1 = newLeftPoint.x;
                newGeom.y1 = newLeftPoint.y;
                newGuid.setGeometry(newGeom);

                //Update guid attributes, emp, lx, ly
                newAttr[trackFields.TRACK_EMP] = emp;
                newAttr[trackFields.TRACK_LX] = newLeftPoint.x;
                newAttr[trackFields.TRACK_LY] = newLeftPoint.y;
                newGuid.setAttributes(newAttr);
            }
        }
    }

    return newGuid;
}

/**
 * gets the point that this mp is on this guid
 * @param guid
 * @param mp
 * @returns {*}
 */
function interpolateMpOnGuid(elem, mp, trackFields) {

    var attrs = elem.attributes,

        trkLX = attrs[trackFields.TRACK_LX],
        trkLY = attrs[trackFields.TRACK_LY],
        trkRX = attrs[trackFields.TRACK_RX],
        trkRY = attrs[trackFields.TRACK_RY],
        trkBMP = attrs[trackFields.TRACK_BMP],
        trkEMP = attrs[trackFields.TRACK_EMP];

    var px = trkEMP === trkBMP ? trkLX : (((trkRX - trkLX) * (mp - trkBMP)) / (trkEMP - trkBMP)) + trkLX,
        py = trkEMP === trkBMP ? trkLY : (((trkRY - trkLY) * (mp - trkBMP)) / (trkEMP - trkBMP)) + trkLY;

    return new Point({
        x: px,
        y: py
    });
}

function getMilepostMarkersOnHostGuid(hostGuid, bmp, bmpSfx, emp, empSfx, trackFields, leftMp, leftSfx) {
    var guidBmp = hostGuid.attributes[trackFields.TRACK_BMP];
    var guidEmp = hostGuid.attributes[trackFields.TRACK_EMP];
    var sfx = hostGuid.attributes[trackFields.TRACK_MPSUF];
    var markers = [];
    var isLeft = false;

    if (typeof (bmp) != 'number') {
        bmp = parseFloat(bmp);
        if (isNaN(bmp)) {
            console.error(bmp + ' is not a number!!!!')
        }
    }

    if (typeof (emp) != 'number') {
        emp = parseFloat(emp);
        if (isNaN(emp)) {
            console.error(emp + ' is not a number!!!!')
        }
    }

    if (sfx == bmpSfx) {
        if ((guidBmp <= bmp && bmp <= guidEmp) || (guidBmp >= bmp && bmp >= guidEmp)) {
            var bmpPointOnGuid = interpolateMpOnGuid(hostGuid, bmp, trackFields);

            isLeft = (bmp == leftMp && bmpSfx == leftSfx);

            markers.push(createMilepostMarker(bmpPointOnGuid, bmp, sfx, isLeft));
        }
    }

    if (sfx == empSfx) {
        if ((guidBmp <= emp && emp <= guidEmp) || (guidBmp >= emp && emp >= guidEmp)) {
            var empPointOnGuid = interpolateMpOnGuid(hostGuid, emp, trackFields);

            isLeft = (emp == leftMp && empSfx == leftSfx);

            markers.push(createMilepostMarker(empPointOnGuid, emp, sfx, isLeft));
        }
    }

    return markers;
}

function createMilepostMarker(mpPoint, mp, sfx, isLeft) {
    //Change the y value so the the marker is below the track
    mpPoint.y += 10;

    if (mp % 1 === 0) {
        var bLength = mp.toString().length;
        mp = mp.toPrecision(bLength + 1);
    }

    return new SvgElement({
        geometry: mpPoint.toJson(),
        symbol: new CompositePointSymbol().addSymbol(
            new SimplePointSymbol({
                color: Color.purple,
                size: 4,
                xOffset: 0,
                yOffset: 0,
                style: 'triangle-up',
            })).addSymbol(new TextSymbol({
                text: mp.toString() + (sfx ? sfx : ''),
                color: Color.purple,
                yOffset: 10,
                xOffset: isLeft ? -10 : 10,
                font: {
                    family: "Tahoma",
                    size: 8
                }
            })).toJson()
    });
}

function getMilepostMarker(guid, mp, sfx, trackFields, isLeft) {
    var mpPointOnGuid = interpolateMpOnGuid(guid, mp, trackFields);
    var color = Color.purple;

    //Change the y co-ordinate of the point so that it is below the track
    mpPointOnGuid.y += 10;

    //If the milepost is an integer add the .0 to the end of the number
    if (mp % 1 === 0) {
        var bLength = mp.toString().length;
        mp = mp.toPrecision(bLength + 1);
    }
    var elem = new SvgElement({
        geometry: mpPointOnGuid.toJson(),
        symbol: new CompositePointSymbol().addSymbol(
            new SimplePointSymbol({
                color: color,
                size: 4,
                xOffset: 0,
                yOffset: 0,
                style: 'triangle-up',
            })).addSymbol(new TextSymbol({
                text: mp.toString() + (sfx ? sfx : ''),
                color: color,
                yOffset: 10,
                xOffset: isLeft ? -10 : 10,
                font: {
                    family: "Tahoma",
                    size: 8
                }
            })).toJson()
    });

    return elem;
}

export const schematicUtil = {
    mpIsLeft,
    convertTextToRangedText,
    getDistinctTrackNames,
    getPartialHostGuid,
    getPartialGuid,
    getMilepostMarkersOnHostGuid,
    getMilepostMarker,
    createMilepostMarker
};
